/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contact } from '../../models/contact';

export interface GetContact$Params {
  id: string;
}

export function getContact(http: HttpClient, rootUrl: string, params: GetContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Contact>> {
  const rb = new RequestBuilder(rootUrl, getContact.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Contact>;
    })
  );
}

getContact.PATH = '/files/{id}/contact';
